module.exports = __webpack_public_path__ + "img/banner_corvus@2x.1bd9bb2a.png";